import { OnInit } from '@angular/core';
var OptionFormComponent = /** @class */ (function () {
    function OptionFormComponent() {
    }
    OptionFormComponent.prototype.ngOnInit = function () {
    };
    return OptionFormComponent;
}());
export { OptionFormComponent };
